export default function BuyGroup() {
	$( '.buy-group>a' ).on( 'click', function ( e ) {
		e.preventDefault();
		$( this ).next( 'ul' ).toggle();
	} );
}